module.exports = __webpack_public_path__ + "img/social-media-templates-kapsalon-extensions-hairdresser-allur-by-steffi-vermeersch-olsene-haar-6.5e9b717c.jpg";